var main = (function($) {

  function init() {

    var siteNavigation = $('.main-menu-area li.menu-item-has-children ul.sub-menu');

      siteNavigation.find( 'a' ).on( 'focus blur', function() {

      $( this ).parents( 'ul' ).toggleClass( 'focus' );

    });

    // Disable form submit on enter key press in text fields, instead focus next field.

    $('input[type=text]').keypress(function(e){

      if ( e.which == 13 ) {

        var index = $('input').index(this) + 1;
        $('input').eq(index).focus();

        e.preventDefault();

      }

    });

    // If we have both #page-content and #anchor-links divs, then this will loop the first
    // and look for H2 and H3 and add them as links into the latter.

    if( $( '#page-content' ).length && $( '#anchor-links' ).length ) {

      $( '#anchor-links' ).html( '<ul id="anchor-links-list"></ul>' );

      function buildSectionAnchorElement( index, heading ) {

        var a = $( '<a>' );

        if( heading.localName ==  'h3' ) {

          console.log( 'joo!' );
          a.attr( 'class', 'sub-anchor' );

        }

        var name = 'goto-anchor-' + index;
        $( heading ).attr( 'name', name );

        a.attr( 'href', '#' + name );
        a.text( $( heading ).text() );

        return a;

      }

      var element_number = 1;
      var headings = $( '#page-content h2,#page-content h3' );

      var our_list = '';

      var sections = headings.map(function(i,e) {

        var a = buildSectionAnchorElement(i,e);
        var p = $(e).next( 'p' );
        var li = $( '<li>' );
        li.append(a);
        $( '#anchor-links-list' ).append( li );
        return li;

      });

    }

    // Sticky anchor links navigation on single article pages.

    window.onscroll = function() {stickyNav()};

    if( document.getElementById( 'anchor-links' ) ) {

      var navbar = document.getElementById( 'anchor-links' );

      var sticky = navbar.offsetTop + 400;

      function stickyNav() {

        if (window.pageYOffset >= sticky) {

          navbar.classList.add( 'fixedsubnavigation' );

        } else {

          navbar.classList.remove( 'fixedsubnavigation' );

        }

      }

    }

    // Add print button to element with class .add-print-button-here

    var print_text = 'Print article';

    if( $( 'html' ).attr( 'lang' ) == 'fi' ) {

      print_text = 'Tulosta artikkeli';

    }

    $( '.add-print-button-here' ).html( '<p><a href="javascript:window.print();" class="print-link">' + print_text + '</a></p>' );

    // Additional information element

    var show_addinfo_text = 'Show additional information';
    var hide_addinfo_text = 'Hide additional information';

    if( $( 'html' ).attr( 'lang' ) == 'fi' ) {

      show_addinfo_text = 'Näytä lisätieto';
      hide_addinfo_text = 'Piilota lisätieto';

    }

    $( '.additional-information' ).each(function( index ) {

      // First we get the current content...
      var additional_information_content = $( this ).html();

      // ...then we add it back together with some new HTML.
      $( this ).html( '<p class="open-additional-information noprint"><a href="#">' + show_addinfo_text + '</a></p><div class="additional-information-content">' + additional_information_content + '</div>' );

    });

    $( '.open-additional-information a' ).click(function(){

      if( $( this ).text() == show_addinfo_text ) {

        $( this ).text( hide_addinfo_text );

      }
      else {

        $( this ).text( show_addinfo_text );

      }

      $( this ).parent().parent().find( '.additional-information-content' ).toggle( 'slow' );

      return false;

    });

    $( '#quotation-information a' ).click(function(){

      $( '#quotation-information' ).click();

      return false;

    });

    $( '#quotation-information' ).click(function(){

      var doc = document;
      var text = doc.getElementById('quotation-information');

      if (doc.body.createTextRange) { // ms
        var range = doc.body.createTextRange();
        range.moveToElementText(text);
        range.select();
      }
      else {
        if (window.getSelection) { // moz, opera, webkit
          var selection = window.getSelection();
          var range = doc.createRange();
          range.selectNodeContents(text);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      }

      console.log('Text should be selected.');

    });

    $('#resetform').click(function(e){

        $('#searchtext').val( '' );

        $('#era-select option:selected').removeAttr('selected');
        $('#theme-select option:selected').removeAttr('selected');

        $('#searchform').submit();

        e.preventDefault();

    });

    $('#empty-era-select').click(function(e){

        $('#era-select option:selected').removeAttr('selected');

        $('#searchform').submit();

        e.preventDefault();

    });

    $('#empty-theme-select').click(function(e){

        $('#theme-select option:selected').removeAttr('selected');

        $('#searchform').submit();

        e.preventDefault();

    });

  }

  // Used from code executed above.
  function selectText(containerid) {
      if (document.selection) {
          var range = document.body.createTextRange();
          range.moveToElementText(document.getElementById(containerid));
          range.select();
      } else if (window.getSelection) {
          var range = document.createRange();
          range.selectNode(document.getElementById(containerid));
          window.getSelection().addRange(range);
      }
  }

  // Open files in new tab.
  $('a[href$=".pdf"]').prop('target', '_blank');
  $('a[href$=".mp3"]').prop('target', '_blank');

  // Here we track some click and send data to Analytics.
  // This data can be found in Analytics under Behavior > Events (in Finnish "Käyttäytyminen > Tapahtumat").
  // From the "Event category" ("Tapahtumaluokka") list you see what has been clicked.
  // From "Event Label" ("Tapahtuman tunniste") you see the value of the link (for example an mail address).
  // Track phone number link clicks (in Analytics: Behaviour > Events, in Finnish Käyttäytyminen > Tapahtumat)
  $('a[href^="tel:"]').click(function(){

    var phonenumber = $( this ).attr( 'href' );

    //console.log( 'You clicked on the phone number ' + phonenumber + '. Hello, is it me you´re looking for?' );

		ga( 'send', 'event', 'Puhelinnumero', 'click', phonenumber, 1 );

  });

  // Track mail address link clicks (in Analytics: Behaviour > Events, in Finnish Käyttäytyminen > Tapahtumat)
  $('a[href^="mailto:"]').click(function(){

    var mailaddress = $( this ).attr( 'href' );

    //console.log( 'You clicked on the mail link ' + mailaddress + '.' );

		ga( 'send', 'event', 'Sähköpostiosoite', 'click', mailaddress, 1 );

  });

  // Track PDF link clicks (in Analytics: Behaviour > Events, in Finnish Käyttäytyminen > Tapahtumat)
  $('a[href$=".pdf"]').click(function(){

    var pdfaddress = $( this ).attr( 'href' );

		ga( 'send', 'event', 'PDF file', 'click', pdfaddress, 1 );

  });

  // Track MP3 link clicks (in Analytics: Behaviour > Events, in Finnish Käyttäytyminen > Tapahtumat)
  $('a[href$=".mp3"]').click(function(){

    var mp3address = $( this ).attr( 'href' );

		ga( 'send', 'event', 'MP3 file', 'click', mp3address, 1 );

  });

  // Track WAV link clicks (in Analytics: Behaviour > Events, in Finnish Käyttäytyminen > Tapahtumat)
  $('a[href$=".wav"]').click(function(){

    var wavaddress = $( this ).attr( 'href' );

		ga( 'send', 'event', 'WAV file', 'click', wavaddress, 1 );

  });

  // Track GIF link clicks (in Analytics: Behaviour > Events, in Finnish Käyttäytyminen > Tapahtumat)
  $('a[href$=".gif"]').click(function(){

    var gifaddress = $( this ).attr( 'href' );

		ga( 'send', 'event', 'GIF file', 'click', gifaddress, 1 );

  });

  // Open external links in new window.
  $('a').each(function() {

    var a = new RegExp('/' + window.location.host + '/');
    var b = new RegExp('javascript:');
    var c = new RegExp('mailto:');
    var d = new RegExp('tel:');

    if( !a.test(this.href) && !b.test(this.href) && !c.test(this.href) && !d.test(this.href) ) {

    $(this).click(function(event) {

      event.preventDefault();
      event.stopPropagation();
      window.open(this.href, '_blank');

    });

    }

  });

  // smooth scroll
  $(function() {
    $('a[href*="#"]:not([href="#"])').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top
          }, 1000);
          return false;
        }
      }
    });
  });

  // Sometimes we have a back button on single pages. This makes it function as the browser back button.

  var thishost = window.location.hostname;

  if ( document.referrer && document.referrer.indexOf(window.location.host) !== -1 ) {

    //console.log('Referrer is same domain.');

    $( '.back-button' ).click(function(e) {

    //console.log('You clicked the button!');

    // We cannot use history.go(-1); because it does not work if we opened the page into a new tab

    window.location.href = document.referrer;
    e.preventDefault();

    });

  }

  /*
  // we almost always need some click functionality
  $('body').click(function(e){

      // do stuff

      e.preventDefault();

  });
  */

  /*
  // Does onload have to be separate? Well, it works.
  $( window ).load(function() {


  });
  */

  return {
    init: init
  };
}(jQuery));
